module.exports = __webpack_public_path__ + "img/legendary_decor_image.acf66ef2.png";